import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';

// ngx-bootstrap's rating renders an inner [role="slider"] span whose
// aria-label is the literal "rating" (RatingConfig, not an @Input), so the
// question text has to be attached from outside. aria-labelledby wins over
// aria-label in accessible-name computation.
@Directive({
  selector: '[appRatingLabelledby]',
  standalone: false
})
export class RatingLabelledbyDirective implements AfterViewInit {
  @Input('appRatingLabelledby') public labelId = '';

  constructor(private readonly _el: ElementRef) {}

  ngAfterViewInit(): void {
    if (!this.labelId) {
      return;
    }

    const slider: HTMLElement =
      this._el.nativeElement.querySelector('[role="slider"]') ||
      this._el.nativeElement;

    slider.setAttribute('aria-labelledby', this.labelId);
  }
}
